module.exports = __webpack_public_path__ + "static/media/Avenir-Heavy.9f8e5b45.woff";